import defaults from '../../../shared/siteConfig.json';

const trimTrailingSlash = (value = '') => String(value).replace(/\/+$/, '');
const stripProtocol = (value = '') => trimTrailingSlash(String(value).replace(/^https?:\/\//i, ''));
const getTelegramHandle = (value = '') =>
  stripProtocol(value)
    .replace(/^t\.me\//i, '')
    .split('/')[0]
    .trim();

const withFallback = (primary, fallback) => {
  const normalized = String(primary || '').trim();
  return normalized || fallback;
};

const buildConfig = () => {
  const site = trimTrailingSlash(withFallback(import.meta.env.VITE_SITE_URL, defaults.site));
  const apiBaseUrl = trimTrailingSlash(withFallback(import.meta.env.VITE_API_BASE_URL, defaults.apiBaseUrl));
  const playStorePackageName = withFallback(
    import.meta.env.VITE_PLAY_STORE_PACKAGE_NAME,
    defaults.playStorePackageName,
  );
  const playStoreUrl = withFallback(
    import.meta.env.VITE_PLAY_STORE_URL,
    defaults.playStoreUrl || `https://play.google.com/store/apps/details?id=${playStorePackageName}`,
  );
  const appPlayStoreUrl = withFallback(
    import.meta.env.VITE_APP_PLAY_STORE_URL,
    defaults.appPlayStoreUrl || `market://details?id=${playStorePackageName}`,
  );
  const telegramCommunityUrl = withFallback(
    import.meta.env.VITE_TELEGRAM_COMMUNITY_URL,
    defaults.telegramCommunityUrl,
  );
  const siteHost = (() => {
    try {
      return new URL(site).host;
    } catch (_) {
      return defaults.site.replace(/^https?:\/\//i, '');
    }
  })();

  return {
    ...defaults,
    brandName: withFallback(import.meta.env.VITE_BRAND_NAME, defaults.brandName),
    brandTagline: withFallback(import.meta.env.VITE_BRAND_TAGLINE, defaults.brandTagline),
    site,
    siteHost,
    apiBaseUrl,
    telegrambot: withFallback(import.meta.env.VITE_TELEGRAM_BOT, defaults.telegrambot),
    telegramCommunityUrl,
    telegramCommunityHandle: getTelegramHandle(telegramCommunityUrl),
    playStorePackageName,
    playStoreUrl,
    appPlayStoreUrl,
    trustpilotUrl: withFallback(import.meta.env.VITE_TRUSTPILOT_URL, defaults.trustpilotUrl),
    supportEmail: withFallback(import.meta.env.VITE_SUPPORT_EMAIL, defaults.supportEmail),
    tonWallet: withFallback(import.meta.env.VITE_TON_WALLET, defaults.tonWallet),
    usdtWallet: withFallback(import.meta.env.VITE_USDT_WALLET, defaults.usdtWallet),
  };
};

export const SITE_CONFIG = buildConfig();

const STRING_REPLACERS = [
  ['https://blablalingo.com', SITE_CONFIG.site],
  ['blablalingo.com', SITE_CONFIG.siteHost],
  ['BlaBlaLingoBot', SITE_CONFIG.telegrambot],
  ['BlaBlaLingo', SITE_CONFIG.brandName],
  ['support@blablalingo.com', SITE_CONFIG.supportEmail],
  ['https://t.me/BlaBlaLingo', SITE_CONFIG.telegramCommunityUrl],
  ['https://t.me/blablalingo', SITE_CONFIG.telegramCommunityUrl],
  ['t.me/BlaBlaLingo', stripProtocol(SITE_CONFIG.telegramCommunityUrl)],
  ['t.me/blablalingo', stripProtocol(SITE_CONFIG.telegramCommunityUrl)],
  ['@BlaBlaLingo', `@${SITE_CONFIG.telegramCommunityHandle}`],
  ['@blablalingo', `@${SITE_CONFIG.telegramCommunityHandle}`],
  ['com.blablalingo.app', SITE_CONFIG.playStorePackageName],
];

export const applySiteBranding = (value) => {
  if (typeof value === 'string') {
    return STRING_REPLACERS.reduce(
      (result, [from, to]) => result.split(from).join(to),
      value,
    );
  }

  if (Array.isArray(value)) {
    return value.map((item) => applySiteBranding(item));
  }

  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, nestedValue]) => [key, applySiteBranding(nestedValue)]),
    );
  }

  return value;
};
